import {
  GET_TERMINAL_SUMMARY_LOADING,
  GET_TERMINAL_SUMMARY_SUCCESS,
  GET_TERMINAL_SUMMARY_FAILD,
} from "../types";

const initialState = {
  terminalData: null,
  loading: null,
  error: null,
};

export const getTerminalSummaryReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_TERMINAL_SUMMARY_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_TERMINAL_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        terminalData: action.payload,
      };
    case GET_TERMINAL_SUMMARY_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
